import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/zoom";

//mainタグにp-topクラスが付いているかを確認
const mainElement = document.querySelector("main.p-top");
//英語ぺージかどうかの判定
const mainElement_en = document.querySelector("main.p-en");

if (mainElement) {
  //MVのスライダー
  const mv_swiper = new Swiper(".js-mv-swiper", {
    loop: true,
    effect: "fade", // フェード切り替え
    fadeEffect: {
      crossFade: true, // クロスフェードを有効にする
    },
    // 自動再生
    autoplay: {
      delay: 4000, // 4秒後に次のスライドへ
      disableOnInteraction: false, // ユーザーが操作しても自動再生を継続
    },
    speed: 4000, // 4秒かけてフェード
  });

  if (!mainElement_en) {
    //TOPICSは日本語のみ
    // カテゴリ数を取得
    let ulElement = document.querySelector(".p-top-topics__category");
    let categories = ulElement.childElementCount - 1;
    let bulletWidth_span = new Array();
    //スマホ用ページネーションの幅を計算
    for (let i = 0; i <= categories; i++) {
      // ①横幅の設定
      const paginationWidth = 270;
      // ② 「.swiper-wrapper」の要素の数を取得
      const wrapperElementsCount = document.querySelectorAll(
        ".js-menu" + ("00" + i).slice(-2) + " .swiper-slide"
      ).length;
      // ③ ① ÷ ② の結果を求める
      const bulletWidth = paginationWidth / wrapperElementsCount;
      bulletWidth_span[i] = bulletWidth;
    }

    // すべてを表示のswiper
    const mySwiper = new Swiper(".js-menu00", {
      loop: true,
      spaceBetween: 10,
      slidesPerGroup: 1,
      slidesPerView: 2.13,
      observer: true, // タブ切り替えのバグ対策
      observeParents: true, // タブ切り替えのバグ対策
      on: {
        init: function () {
          updateExtraPagination(this, "00");
        },
        slideChange: function () {
          updateExtraPagination(this, "00");
        },
      },
      pagination: {
        el: ".top-swiper-pagination00",
        renderBullet: function (index, className) {
          return (
            '<span class="' +
            className +
            '" style="width:' +
            bulletWidth_span[0] +
            'px"></span>'
          );
        },
      },
      breakpoints: {
        769: {
          // スライドの表示枚数：769px以上の場合
          navigation: {
            nextEl: ".top-swiper-next00",
            prevEl: ".top-swiper-prev00",
          },
          slidesPerView: 4,
          scrollbar: {
            el: ".top-swiper-scrollbar00", // スクロールバーとして認識させるクラス
            draggable: false, // ループモードにするとドラッグ不可になります
            scrollbarSnapOnRelease: true,
          },
        },
      },
    });

    // カテゴリ毎のswiper
    // カテゴリの数Swiperを宣言
    var categoryList = new Array();
    for (let i = 1; i <= categories; i++) {
      let wrapper = document.querySelector(
        ".js-menu" + ("00" + i).slice(-2) + " .swiper-wrapper"
      );
      if (4 < wrapper.childElementCount) {
        //記事数が5件以上の場合
        categoryList[i] = new Swiper(".js-menu" + ("00" + i).slice(-2), {
          loop: true,
          observer: true,
          observeParents: true,
          spaceBetween: 10,
          slidesPerGroup: 1,
          slidesPerView: 2.13,
          on: {
            init: function () {
              updateExtraPagination(this, ("00" + i).slice(-2));
            },
            slideChange: function () {
              updateExtraPagination(this, ("00" + i).slice(-2));
            },
          },
          pagination: {
            el: ".top-swiper-pagination" + ("00" + i).slice(-2),
            renderBullet: function (index, className) {
              return (
                '<span class="' +
                className +
                '" style="width:' +
                bulletWidth_span[i] +
                'px"></span>'
              );
            },
          },
          breakpoints: {
            // スライドの表示枚数：769px以上の場合
            769: {
              // 前後の矢印
              navigation: {
                nextEl: ".top-swiper-next" + ("00" + i).slice(-2),
                prevEl: ".top-swiper-prev" + ("00" + i).slice(-2),
              },
              slidesPerView: 4,
              scrollbar: {
                el: ".top-swiper-scrollbar" + ("00" + i).slice(-2),
                draggable: false, // ループモードにするとドラッグ不可になります
                lockClass: "swiper-scrollbar-lock",
              },
            },
          },
        });
      } else {
        //記事数が5件未満の場合
        if (
          //記事件数が3件以上かつスマホの場合
          2 < wrapper.childElementCount &&
          window.matchMedia("(max-width: 768px)").matches
        ) {
          categoryList[i] = new Swiper(".js-menu" + ("00" + i).slice(-2), {
            loop: true,
            observer: true,
            observeParents: true,
            spaceBetween: 10,
            slidesPerView: 2.13,
            on: {
              init: function () {
                updateExtraPagination(this, ("00" + i).slice(-2));
              },
              slideChange: function () {
                updateExtraPagination(this, ("00" + i).slice(-2));
              },
            },
            pagination: {
              el: ".top-swiper-pagination" + ("00" + i).slice(-2),
              renderBullet: function (index, className) {
                return (
                  '<span class="' +
                  className +
                  '" style="width:' +
                  bulletWidth_span[i] +
                  'px"></span>'
                );
              },
            },
          });
        } else {
          categoryList[i] = new Swiper(".js-menu" + ("00" + i).slice(-2), {
            loop: true,
            spaceBetween: 10,
            slidesPerView: 2.13,
            observer: true,
            observeParents: true,
            pagination: {
              el: ".top-swiper-pagination" + ("00" + i).slice(-2),
            },
            breakpoints: {
              // スライドの表示枚数：769px以上の場合
              769: {
                slidesPerView: 4,
                loop: false,
                draggable: false, // ループモードにするとドラッグ不可になります
              },
            },
          });
        }
      }
    }
    function updateExtraPagination(swiper, i) {
      var currentIndex = swiper.realIndex + 1;
      var totalSlides = swiper.slides.length;
      document.querySelector(".top-swiper-pagination-extra" + i).innerHTML =
        ("00" + currentIndex).slice(-2) +
        "<span> | </span>" +
        ("00" + totalSlides).slice(-2);
    }
  }

  //Conceptのスライダー
  const conceptSwiper = new Swiper(".js-concept", {
    loop: true,
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    effect: "fade",
    speed: 1000,
  });
  //Breakfastのスライダー
  const breakfastSwiper = new Swiper(".js-breakfast", {
    loop: true,
    slidesPerView: 2.5,
    speed: 800,
    allowTouchMove: false,
    spaceBetween: 2,
    easing: "ease-in",
    autoplay: {
      delay: 3000,
    },
    breakpoints: {
      // スライドの表示枚数：769px以上の場合
      768: {
        slidesPerView: 4.7,
      },
    },
  });

  //おすすめプランのスライダー
  const planSwiper = new Swiper(".js-plan", {
    loop: true,
    slidesPerView: 2.1,
    spaceBetween: 10,
    on: {
      init: function () {
        if (this.slides.length > 4) {
          updateExtraPagination_plan(this);
        } else if (
          2 < this.slides.length &&
          window.matchMedia("(max-width: 768px)").matches
        ) {
          updateExtraPagination_plan(this);
        }
      },
      slideChange: function () {
        if (this.slides.length > 4) {
          updateExtraPagination_plan(this);
        } else if (
          2 < this.slides.length &&
          window.matchMedia("(max-width: 768px)").matches
        ) {
          updateExtraPagination_plan(this);
        }
      },
    },
    pagination: {
      el: ".p-top-plans-pagination",
      renderBullet: function (index, className) {
        return (
          '<span class="' +
          className +
          '" style="width:' +
          270 / this.slides.length +
          'px"></span>'
        );
      },
    },
    breakpoints: {
      // スライドの表示枚数：769px以上の場合
      768: {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: ".plan-swiper-next",
          prevEl: ".plan-swiper-prev",
        },
        scrollbar: {
          el: ".p-top-plans-scrollbar",
          draggable: false, // ループモードにするとドラッグ不可になります
        },
      },
    },
  });
  function updateExtraPagination_plan(swiper) {
    var currentIndex = swiper.realIndex + 1;
    var totalSlides = swiper.slides.length;
    document.querySelector(".p-top-plans-pagination-extra").innerHTML =
      ("00" + currentIndex).slice(-2) +
      "<span> | </span>" +
      ("00" + totalSlides).slice(-2);
  }

  //エクスペリエンスのスライダー
  const sightseeingSwiper = new Swiper(".js-sightseeing", {
    loop: true,
    slidesPerView: 2.4,
    spaceBetween: 10,
    speed: 600,
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      // スライドの表示枚数：769px以上の場合
      768: {
        slidesPerView: mainElement_en ? 2.8 : 3.2,
        spaceBetween: 20,
      },
    },
  });
}
